export default __webpack_public_path__ + "static/media-card-76961ee61bda24f09e4de203032bb636.jpg";